export class Testassignment
{
  getFreelancerbyIdAPI: any;
  ArticleTitleAPI: any;
  FreelancertestallocationAPI: any;
  ArticleListAPI: any;
}
